import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { SignalRService, WebSocketEvents } from "@app/main/modules/foundation/_routes/developerConsole/signalr.service";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { CameraDiagnosticRecordType } from "../_enums/CameraDiagnosticRecordType";
import { ICameraDiagnosticRecord } from "../_models/ICameraDiagnosticRecord";
import { ICameraDiagnosticRecordQueryOptions } from "../_models/ICameraDiagnosticRecordQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class CameraEventService {
    constructor(
        private readonly http: HttpClient,
        private readonly signalRService: SignalRService) { }

    diagMessageReceived = new Subject<string>();

    getIncomingDiagMessages(serial: string): Observable<string> {
        this.signalRService.initialise().then(() => {
            this.signalRService.joinDeviceGroup(serial);
            this.signalRService.registerEvents<string>(WebSocketEvents.DiagnosticPacketUpdate, this.diagMessageReceived);
        });

        return this.diagMessageReceived;
    }

    getCameraEvents(options: ICameraDiagnosticRecordQueryOptions): Observable<ICameraDiagnosticRecord[]> {
        const params = getOptionsQueryParams(options);

        return this.http.get<ICameraDiagnosticRecord[]>(`/api/cameras/commserver/diagnosticrecords`, params).pipe(
            map(events => {
                return this.parseEventPayloads(events);
            })
        );
    }

    getGPSCameraEvents(options: ICameraDiagnosticRecordQueryOptions): Observable<ICameraDiagnosticRecord[]> {
        options.RecordType = CameraDiagnosticRecordType.Gps;
        const params = getOptionsQueryParams(options);

        return this.http.get<ICameraDiagnosticRecord[]>(`/api/cameras/commserver/diagnosticrecords`, params).pipe(
            map(events => {
                return this.parseEventPayloads(events);
            })
        );
    }

    private parseEventPayloads(events: ICameraDiagnosticRecord[]): ICameraDiagnosticRecord[] {
        return events.map(event => {
            event.parsedPayload = JSON.parse(event.Payload);
            return event;
        })
    }
}
